module.exports = __webpack_public_path__ + "fonts/SalesforceSans-Regular.aa41afdaceb8b78c56529555448bcf44.woff2";